import { z } from "zod/v4";

export const CreationReasonSchema = z.enum([
  "self_purchase",
  "gift_for_someone_else",
  "gift_for_unknown_recipient",
  "venue_giveaway",
]);

export const BaseVoucherSchema = z.object({
  uuid: z.string(),
  venueUuid: z.string(),
  venueName: z.string().nullable(),
  purchaserUuid: z.string().nullable(),
  ownerUuid: z.string().nullable(),
  issuerUuid: z.string().nullable(),
  voucherTemplateUuid: z.string().nullable(),
  staffMemberUuid: z.string().nullable(),
  recipientName: z.string().nullable(),
  recipientEmail: z.string().nullable(),
  purchaserEmail: z.string().nullable(),
  voucherReceiverEmail: z.string().nullable(),
  purchasePriceInCents: z.number().int(),
  openingBalanceInCents: z.number().int(),
  balanceInCents: z.number().int(),
  marketingDescription: z.string().nullable(),
  voucherName: z.string().nullable(),
  shareEmail: z.boolean().default(false),
  senderName: z.string().nullable(),
  claimedAt: z.string().nullable(),
  expiresAt: z.string().nullable(),
  creationReason: CreationReasonSchema,
  creationChannel: z
    .enum(["bustle_online", "bustle_hub", "unknown"])
    .catch("unknown"),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type BaseVoucher = z.infer<typeof BaseVoucherSchema>;
